import { memo, useCallback } from 'react';
import { SectionForm, Spacer, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import IntegrationItem from './IntegrationItem';

const IntegrationsSection = memo(({ integrations, selectedIntegrations, onChange }) => {
    const handleToggle = useCallback(
        (integrationId, isChecked) => {
            if (isChecked) {
                onChange([...selectedIntegrations, integrationId]);
            } else {
                onChange(selectedIntegrations.filter((id) => id !== integrationId));
            }
        },
        [selectedIntegrations, onChange],
    );

    return (
        <SectionForm title={getLiteral('automation_trigger_integrations')}>
            <Spacer y={4} />
            <Text>{getLiteral('automation_trigger_integrations_desc')}</Text>
            <Spacer y={4} />
            <div className="fm-automation-builder__integrations-list">
                {integrations.map((integration) => (
                    <IntegrationItem
                        key={integration.id}
                        integration={integration}
                        isChecked={selectedIntegrations?.includes(integration.id) || false}
                        onToggle={handleToggle}
                    />
                ))}
            </div>
        </SectionForm>
    );
});

export default IntegrationsSection;
